import { Common, color } from '@stockbit/ui';
import useCountdown from 'hooks/useCountdown';

const { Text } = Common;

interface TimerOtpProps {
  onResend: () => void;
}
const INITIAL_TIMER_SECOND = 60;

function TimerOtp({ onResend }: TimerOtpProps) {
  const { seconds, minutes, isFinished, onEnd } = useCountdown({
    onResend,
    time: INITIAL_TIMER_SECOND,
  });

  return (
    <Text align="center" pt="12px">
      {isFinished ? (
        <Text as="a" size="14px" onClick={onEnd}>
          Kirim Ulang
        </Text>
      ) : (
        <Text size="14px" align="center" color={color.highgray}>
          Kirim Ulang ({minutes}:{seconds})
        </Text>
      )}
    </Text>
  );
}

export default TimerOtp;
